import { lt } from '@mews/framework';
import { EmptyState } from '@optimus-web/core';

export const EmptyAttachmentState = () => {
    return (
        <EmptyState
            primaryText={lt('ContractsNoAttachmentsFoundPrimaryText')}
            secondaryText={lt('ContractsGenerateContractNoAttachmentsFoundSecondaryText')}
        />
    );
};
